module.exports = __webpack_public_path__ + "static/media/full_2.122baad1.jpg";